/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const h = 'is-hidden';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_thin" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_thin" /></svg></button>';

	// JSON取得 =====================================================
	const getJSONpickup = (_key) => {
		return $.getJSON(`/ajax/solution/pickup/${_key}.json`);
	}

	// <ソリューションTOP> ============================================
	// メインスライダー
	const mainSlider = () => {
		if($('.js-mainSlider').length) {
			$('.js-mainSlider').slick({
				infinite: true,
				speed: 1000,
				autoplay: false,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		}
	};
	// ソリューション検索
	const searchModal = () => {
		if($('.js-searchModal').length) {
			// モーダル開く
			$('.js-searchModal-open').on('click', (e) => {
				$('.js-searchModal').addClass(a);
				fixedOnContainer();
			});

			// モーダル閉じる
			$('.js-searchModal-close').on('click', (e) => {
				$('.js-searchModal').removeClass(a);
				fixedOffContainer();
			})
			$('.js-searchModal').on('click', (e) => {
				if($('.js-searchModal.is-active').length) {
					if(!$(e.target).closest('.solution-search-inner, .solution-search-btn').length) {
						$('.js-searchModal').removeClass(a);
						fixedOffContainer();
					}
				}
			});

			// <PC>
			$('.js-searchModal-tab').on('click', (e) => {
				$('.js-searchModal-tab').removeClass(a);
				$(e.currentTarget).addClass(a);
			});

			// <TABLET/SP>
			$('.solution-search-select').on('click', (e) => {
				$('.mod-tab01-wrap._sp').toggleClass(a);
			});
			$('.js-select-sp').on('click', (e) => {
				let thisName = $(e.currentTarget).attr('data-name');
				let thisTxt  = $(e.currentTarget).find('.__txt').text();
				$('.mod-tab01-wrap._sp').removeClass(a)
				$('.solution-search-select').find('.__txt').text(thisTxt);
				$('.solution-search-toggle-block').removeClass(a);
				$('.solution-search-toggle-block-wrap').removeClass(a);
				$('.solution-search-toggle-block[data-name="'+ thisName +'"]').addClass(a);
				$('.solution-search-toggle-block[data-name="'+ thisName +'"]').parents('.solution-search-toggle-block-wrap').addClass(a);
			});

			// リセット
			$('.js-search-reset').on('click', (e) => {
				$(e.currentTarget).parents('.js-toggleBlock').find('.mod-check-input').prop('checked', false);
			});
		}

		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};
	};
	// ピックアップ
	const pickupTag = () => {
		if($('.js-pickup-tagList').length) {
			let $lang = '';
			if(location.pathname.indexOf('/en/') === 0) {
				$lang = 'en';
			}
			$('.js-pickup-tagList').each((idx,ele) => {
				let thisKey = $(ele).attr('data-name');
				let arr = [];
				getJSONpickup(thisKey).then((data) => {
					let piclupData = data.rt_bn_pickup_list;
					if(piclupData.length) {
						for(let i = 0; i < piclupData.length; i++) {
							arr.push({
								'name' : piclupData[i].cf_pnt_name,
								'name_en' : piclupData[i].cf_pnt_name_en,
								'starus' :  piclupData[i].cf_pnt_tag_status,
								'order' : piclupData[i].cf_pnt_order,
								'tags' : piclupData[i].cf_pnt_tags
							});
						}
					}
				}).then(() => {
					if(arr.length) {
						arr.sort((a, b) => {
							// 昇順
							if(a.order < b.order) return -1;
							if(a.order > b.order) return 1;
						});
					};
					let html = '';
					arr.forEach((elem) => {
						let _name = elem.name;
						let _name_en = elem.name_en;
						let _starus = elem.starus;
						let _tags = elem.tags;
						let url = new URL(window.location.href);
						if(_starus === 1) {
							if(_tags.length) {
								for(let i = 0; i < _tags.length; i++) {
									if(_tags[i].cf_nt_tag_status === 1) {
										url.searchParams.append('p_'+ _tags[i].cf_nt_group_code, _tags[i]._key);
									}
								}
							}
						}
						html += '<li class="pure-u-1-4 pure-u-lg-1-2"><a href="';
						if($lang === 'en') {
							html += '/en';
						}
						html += '/solution/result/'+ url.search +'" class="solution-top-tab-block-btn">'+
						'<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_bold"></use></svg>'+
						'<span class="__txt">';
						if($lang === 'en') {
							html += _name_en;
						} else {
							html += _name;
						}
						html += '</span></a></li>';
					}); 
					$(ele).append(html);
				});
			});
		}
	};
	// <検索結果> ====================================================
	const resultSortChange = () => {
		const sortSelect = $('.js-sort');
		if(sortSelect.length) {
			let $path = location.pathname;
			let params = new URLSearchParams(location.search);
			let flg = 'new';
			let pagerNew = params.get('rt_bn_news_list_new_skip');
			let pagerOld = params.get('rt_bn_news_list_old_skip');
			let sortParam = params.get('sort');
			
			if(sortParam !== null) {
				flg = sortParam;
			}

			// 初期表示時
			$('.js-sortBlock.'+ flg).removeClass('di_none');
			$('.js-sort option[value="'+ flg +'"]').prop('selected', true);
			$('.js-sortBlock.'+ flg).find('.mod-paginate').find('a').each((idx,ele) => {
				let thisParams = new URLSearchParams($(ele).attr('href').split('?')[1]);
				thisParams.set('sort', flg);
				$(ele).attr('href', $(ele).attr('href').split('?')[0] +'?'+ thisParams.toString());
			});
						
			// 並び順変更時
			sortSelect.on('change', () => {
				let selectedSort = sortSelect.val();
				// 1ページ目で表示順チェンジしたとき
				if(pagerNew === null || pagerOld === null) {
					$('.js-sortBlock').addClass('di_none');
					$('.js-sortBlock.'+ selectedSort).removeClass('di_none');
					$('.js-sortBlock.'+ selectedSort).find('.mod-paginate').find('a').each((idx,ele) => {
						let thisParams = new URLSearchParams($(ele).attr('href').split('?')[1]);
						thisParams.set('sort', selectedSort);
						$(ele).attr('href', $(ele).attr('href').split('?')[0] +'?'+ thisParams.toString());
					});
				} else {
					// 2ページ目以外で表示順チェンジしたとき
					params.delete('rt_bn_news_list_new_skip');
					params.delete('rt_bn_news_list_old_skip');
					params.set('sort', selectedSort);
					location.href = $path +'?'+ params.toString();
				}
			});
		}
	};

	// <拠点> ========================================================
	const setBaseMapImg = () => {
		$(".js-map-hokkaido-tohoku").mouseover(function(){
			$('.__hokkaido-tohoku').addClass(a)
			$('.js-map-hokkaido-tohoku').addClass(a)
			$('.js-line-hokkaido-tohoku').addClass(a)
		}).mouseout(function(){
			$('.__hokkaido-tohoku').removeClass(a)
			$('.js-map-hokkaido-tohoku').removeClass(a)
			$('.js-line-hokkaido-tohoku').removeClass(a)
		})
		$(".js-map-kanto-koushinetsu").mouseover(function(){
			$('.__kanto-koushinetsu').addClass(a)
			$('.js-map-kanto-koushinetsu').addClass(a)
			$('.js-line-kanto-koushinetsu').addClass(a)
		}).mouseout(function(){
			$('.__kanto-koushinetsu').removeClass(a)
			$('.js-map-kanto-koushinetsu').removeClass(a)
			$('.js-line-kanto-koushinetsu').removeClass(a)
		})
		$(".js-map-chubu").mouseover(function(){
			$('.__chubu').addClass(a)
			$('.js-map-chubu').addClass(a)
			$('.js-line-chubu').addClass(a)
		}).mouseout(function(){
			$('.__chubu').removeClass(a)
			$('.js-map-chubu').removeClass(a)
			$('.js-line-chubu').removeClass(a)
		})
		$(".js-map-kansai").mouseover(function(){
			$('.__kansai').addClass(a)
			$('.js-map-kansai').addClass(a)
			$('.js-line-kansai').addClass(a)
		}).mouseout(function(){
			$('.__kansai').removeClass(a)
			$('.js-map-kansai').removeClass(a)
			$('.js-line-kansai').removeClass(a)
		})
		$(".js-map-chugoku-shikoku").mouseover(function(){
			$('.__chugoku-shikoku').addClass(a)
			$('.js-map-chugoku-shikoku').addClass(a)
			$('.js-line-chugoku-shikoku').addClass(a)
		}).mouseout(function(){
			$('.__chugoku-shikoku').removeClass(a)
			$('.js-map-chugoku-shikoku').removeClass(a)
			$('.js-line-chugoku-shikoku').removeClass(a)
		})
		$(".js-map-kyusyu").mouseover(function(){
			$('.__kyusyu').addClass(a)
			$('.js-map-kyusyu').addClass(a)
			$('.js-line-kyusyu').addClass(a)
		}).mouseout(function(){
			$('.__kyusyu').removeClass(a)
			$('.js-map-kyusyu').removeClass(a)
			$('.js-line-kyusyu').removeClass(a)
		})

		$(".__hokkaido-tohoku").mouseover(function(){
			$('.__hokkaido-tohoku').addClass(a)
			$('.js-map-hokkaido-tohoku').addClass(a)
			$('.js-line-hokkaido-tohoku').addClass(a)
		}).mouseout(function(){
			$('.__hokkaido-tohoku').removeClass(a)
			$('.js-map-hokkaido-tohoku').removeClass(a)
			$('.js-line-hokkaido-tohoku').removeClass(a)
		})
		$(".__kanto-koushinetsu").mouseover(function(){
			$('.__kanto-koushinetsu').addClass(a)
			$('.js-map-kanto-koushinetsu').addClass(a)
			$('.js-line-kanto-koushinetsu').addClass(a)
		}).mouseout(function(){
			$('.__kanto-koushinetsu').removeClass(a)
			$('.js-map-kanto-koushinetsu').removeClass(a)
			$('.js-line-kanto-koushinetsu').removeClass(a)
		})
		$(".__chubu").mouseover(function(){
			$('.__chubu').addClass(a)
			$('.js-map-chubu').addClass(a)
			$('.js-line-chubu').addClass(a)
		}).mouseout(function(){
			$('.__chubu').removeClass(a)
			$('.js-map-chubu').removeClass(a)
			$('.js-line-chubu').removeClass(a)
		})
		$(".__kansai").mouseover(function(){
			$('.__kansai').addClass(a)
			$('.js-map-kansai').addClass(a)
			$('.js-line-kansai').addClass(a)
		}).mouseout(function(){
			$('.__kansai').removeClass(a)
			$('.js-map-kansai').removeClass(a)
			$('.js-line-kansai').removeClass(a)
		})
		$(".__chugoku-shikoku").mouseover(function(){
			$('.__chugoku-shikoku').addClass(a)
			$('.js-map-chugoku-shikoku').addClass(a)
			$('.js-line-chugoku-shikoku').addClass(a)
		}).mouseout(function(){
			$('.__chugoku-shikoku').removeClass(a)
			$('.js-map-chugoku-shikoku').removeClass(a)
			$('.js-line-chugoku-shikoku').removeClass(a)
		})
		$(".__kyusyu").mouseover(function(){
			$('.__kyusyu').addClass(a)
			$('.js-map-kyusyu').addClass(a)
			$('.js-line-kyusyu').addClass(a)
		}).mouseout(function(){
			$('.__kyusyu').removeClass(a)
			$('.js-map-kyusyu').removeClass(a)
			$('.js-line-kyusyu').removeClass(a)
		})

	}

	// ==============================================================================
	mainSlider();
	searchModal();
	pickupTag();
	resultSortChange();
	setBaseMapImg()

})(window.jQuery, window.KONOIKE);
